import React from 'react';
import { Sparkles, Plus } from 'lucide-react';
import { PageTitle } from '../../ui/PageTitle';

interface PersonagensHeaderProps {
  onAddPersonagem: () => void;
}

export const PersonagensHeader: React.FC<PersonagensHeaderProps> = ({ onAddPersonagem }) => {
  return (
    <div className="mx-2 sm:mx-4 lg:mx-6 mt-2 mb-6">
      <PageTitle
        title="Personagens"
        subtitle="Cadastre os personagens disponíveis e seus preços base"
      >
        <div className="h-12 w-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/30">
          <Sparkles className="w-7 h-7 text-white" />
        </div>

        <button
          onClick={onAddPersonagem}
          className="px-4 py-2.5 bg-white/20 backdrop-blur-sm text-white rounded-xl hover:bg-white/30 flex items-center gap-2 font-semibold border border-white/30 transition-all duration-200"
        >
          <Plus className="w-4 h-4" />
          Novo Personagem
        </button>
      </PageTitle>
    </div>
  );
};
